import React from 'react';
import PropTypes from 'prop-types';

const Letter = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="グループ_3903" data-name="グループ 3903" xmlns="http://www.w3.org/2000/svg" width="16.84" height="12.532" viewBox="0 0 16.84 12.532" {...other}>
      <g id="グループ_3904" data-name="グループ 3904">
        <path id="パス_3649" data-name="パス 3649" d="M15.943,12.532H.9a.9.9,0,0,1-.9-.9V.9A.9.9,0,0,1,.9,0H15.943a.9.9,0,0,1,.9.9V11.635a.9.9,0,0,1-.9.9" fill="#d4d5d7" />
        <path id="パス_3650" data-name="パス 3650" d="M13.024,3.131,10.047,5.143,7.92,6.58l-5.1-3.449" transform="translate(0.5 0.597)" fill="none" stroke="#71737c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      </g>
    </svg>
  );
}

Letter.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Letter.defaultProps = {
  color: '#000000',
  width: 22,
  height: 22,
};

export default Letter;



// WEBPACK FOOTER //
// ./src/components/Icons/Letter.jsx